export const UNSPLASH_IMAGES = 'Unsplash';
export const UPLOADED_IMAGES = 'Images';
export const UPLOADED_VIDEOS = 'Video';
